module.exports = __webpack_public_path__ + "img/STERiJECT_05.5d43415a.png";